import React, { useEffect, useRef } from 'react';
import mobileImage1 from '../assets/mbscreen1.png';
import mobileImage2 from '../assets/mbscreen2.png';
import observer from '../utils/observer';

const MobileUiImage = () => {
  const sectionRefValue = useRef(null);
  const imageOneRefValue = useRef(null);
  const imageTwoRefValue = useRef(null);

  useEffect(() => {
    observer(sectionRefValue, 'section-hidden');
    observer(imageOneRefValue, 'lazy-load-image');
    observer(imageTwoRefValue, 'lazy-load-image');
  }, [sectionRefValue,imageOneRefValue,imageTwoRefValue]);

  return (
    <div className="mobile-ui-container section-hidden" ref={sectionRefValue}>
      <div className="mobile-ui-image-container">
        <img
          src={mobileImage1}
          alt={'clean meal for consistent diet'}
          className="mobile-ui-image lazy-load-image"
          ref={imageOneRefValue}
        />
      </div>
      <div className="mobile-ui-image-container">
        <img
          src={mobileImage2}
          alt={'keep track of your journey'}
          className="mobile-ui-image lazy-load-image"
          ref={imageTwoRefValue}
        />
      </div>
    </div>
  );
};

export default MobileUiImage;
